import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { findRecord } from '@warp-drive/utilities/json-api';
import type PartnerService from 'tio-employee/services/partner';
import type { Store } from '@warp-drive/core';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type { Company as CompanyModel } from 'tio-data/data/resources/company.type';

export default class AuthenticatedAdminEmployeesAddRoute extends Route {
  @service declare partner: PartnerService;
  @service declare store: Store;

  async model() {
    const employee = this.store.createRecord<EmployeeModel>('employee', {});
    const { content } = (await this.store.request(
      findRecord<CompanyModel>('company', this.partner.company!.id!, {
        include: 'company-setting,plans',
      })
    )) as { content: { data: CompanyModel } };
    employee.company = content.data;
    return employee;
  }
}
